import { AtonTargetInfo, extractAtonTargetInfos } from './atonTargetInfo';
import {
  BaseStationTargetInfo,
  extractBasestationTargetInfos,
} from './baseStationTargetInfo';
import { extractShipInfos, ShipInfo } from './shipInfo';
import {
  extractVirtualAtonTargetInfos,
  VirtualAtonTargetInfo,
} from './virtualAtonTargetInfo';
import { extractMethydTargetInfos, MethydTargetInfo } from './methydTargetInfo';
import { VesselResult } from '@ais-ui/api-spec/shipdb';
import {
  EnvironmentalTargetInfo,
  extractEnvironmentalTargetInfos,
} from './environmentalTargetInfo';

interface TargetInfo {
  lat: number;
  lon: number;
  type: string;
  mmsi: string;
  values: {
    id: string;
    value: string;
    name: string;
  }[];
  values_json: { [key: string]: any };
}

export interface ExtractedTargetInfo {
  extractedTargetInfo: TargetInfoType[];
  extractedTargetInfoType: TargetTypeEnum;
}

export type TargetInfoType =
  | BaseStationTargetInfo
  | AtonTargetInfo
  | ShipInfo
  | VirtualAtonTargetInfo
  | MethydTargetInfo
  | VesselResult
  | EnvironmentalTargetInfo;

export enum TargetTypeEnum {
  Ship = 'ship',
  BaseStation = 'basestation',
  Aton = 'aton',
  VirtualAton = 'virtual aton',
  Methyd = 'methyd',
  ExtendedVessel = 'extended vessel',
  Environmental = 'environmental',
}

export interface QueryPointResult {
  targetInfo: TargetInfo[];
}

export function getTargetInfoName(
  targetInfo: TargetInfoType,
  targetType: TargetTypeEnum
) {
  if ('name' in targetInfo) {
    return targetInfo?.name;
  }
  if (targetType === TargetTypeEnum.BaseStation) {
    return 'Basestation';
  } else if (targetType === TargetTypeEnum.Methyd) {
    return 'MetHyd';
  } else if (targetType === TargetTypeEnum.Environmental) {
    return 'Environmental';
  } else if (targetType === TargetTypeEnum.ExtendedVessel) {
    return (targetInfo as VesselResult)?.basic?.vesselName
      ? (targetInfo as VesselResult)?.basic?.vesselName
      : 'Unknown';
  }
  return 'Unknown';
}

export function extractTargetInfos(
  result: QueryPointResult
): ExtractedTargetInfo {
  const tmpExtractedTargetInfo: ExtractedTargetInfo = {
    extractedTargetInfo: [],
    extractedTargetInfoType: TargetTypeEnum.Ship,
  };

  const lowerCaseType = result?.targetInfo?.[0]?.type.toLowerCase();
  if (lowerCaseType === 'basestation') {
    tmpExtractedTargetInfo.extractedTargetInfoType = TargetTypeEnum.BaseStation;
    tmpExtractedTargetInfo.extractedTargetInfo =
      extractBasestationTargetInfos(result);
  } else if (lowerCaseType === 'aton') {
    tmpExtractedTargetInfo.extractedTargetInfoType = TargetTypeEnum.Aton;
    tmpExtractedTargetInfo.extractedTargetInfo = extractAtonTargetInfos(result);
  } else if (lowerCaseType === 'virtual aton') {
    tmpExtractedTargetInfo.extractedTargetInfoType = TargetTypeEnum.VirtualAton;
    tmpExtractedTargetInfo.extractedTargetInfo =
      extractVirtualAtonTargetInfos(result);
  } else if (lowerCaseType === 'methyd') {
    tmpExtractedTargetInfo.extractedTargetInfoType = TargetTypeEnum.Methyd;
    tmpExtractedTargetInfo.extractedTargetInfo =
      extractMethydTargetInfos(result);
  } else if (lowerCaseType === 'environmental') {
    tmpExtractedTargetInfo.extractedTargetInfoType =
      TargetTypeEnum.Environmental;
    tmpExtractedTargetInfo.extractedTargetInfo =
      extractEnvironmentalTargetInfos(result);
  } else {
    tmpExtractedTargetInfo.extractedTargetInfo = extractShipInfos(result);
  }
  return tmpExtractedTargetInfo;
}
